export const HOME = "/";
export const ROOMS = "/rooms";
export const SINGLE_ROOM = "/rooms/:id";
export const ERROR_404 = "";
